export default __webpack_public_path__ + "static/media/2.d5a96401.png";